import { isProduction } from '../environment';
import { DashboardApi as RealDashboardApi } from './dashboard-api';
import { DashboardApi as MockDashboardApi } from './mock-dashboard-api';

const SelectedDashboardApi = isProduction() ? RealDashboardApi : MockDashboardApi;

export default SelectedDashboardApi;